var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4657 6.69284L13.322 4.83659C14.1079 4.12027 15.1396 3.73431 16.2027 3.75892C17.2658 3.78353 18.2785 4.21682 19.0304 4.96874C19.7824 5.72067 20.2157 6.7334 20.2403 7.7965C20.2649 8.85959 19.8789 9.8913 19.1626 10.6772L16.5095 13.321C16.1271 13.7048 15.6727 14.0093 15.1724 14.2171C14.6721 14.4249 14.1356 14.5318 13.5938 14.5318C13.0521 14.5318 12.5156 14.4249 12.0153 14.2171C11.515 14.0093 11.0606 13.7048 10.6782 13.321",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5344 17.3078L10.6782 19.164C9.89227 19.8803 8.86057 20.2663 7.79748 20.2417C6.73438 20.2171 5.72164 19.7838 4.96972 19.0319C4.2178 18.2799 3.78451 17.2672 3.7599 16.2041C3.73529 15.141 4.12124 14.1093 4.83756 13.3234L7.49069 10.6796C7.87306 10.2958 8.32744 9.9913 8.82778 9.78351C9.32811 9.57571 9.86455 9.46875 10.4063 9.46875C10.9481 9.46875 11.4845 9.57571 11.9849 9.78351C12.4852 9.9913 12.9396 10.2958 13.3219 10.6796",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.85ae9df1bc321c13ce1a06ec0460d982.svg";
export { ForwardRef as ReactComponent };